import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import transVI from './locales/vi/index.json';
import transEN from './locales/en/index.json';
import { LOCALE, LOCALE_VI, LOCALE_EN } from 'consts/common.const';

// locale stored
const locale = localStorage.getItem(LOCALE);

const resources = {
  [LOCALE_VI]: {
    translation: transVI,
  },
  [LOCALE_EN]: {
    translation: transEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: locale || LOCALE_VI,
  fallbackLng: LOCALE_VI,
  interpolation: {
    escapeValue: false, // React already does escaping
  },
  react: {
    useSuspense: false,
  },
} as any);

export default i18n;
